var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.92 56.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#abe968;}.cls-2{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-3{fill:#1c0e37;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.46,
    cy: 28.46,
    r: 28.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.79,20.46s4.58-6.2,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.1,20.46s4.58-6.2,8.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.6,29.52a3.12,3.12,0,0,0-1.27,1.89c-1.24,4.7,1.79,8.86,6.13,10.33A21.21,21.21,0,0,0,38.1,41c2.27-1.11,5.73-3.59,5.73-6.45,0-2.54-3.24-3.33-5.23-3.62-3.84-.54-7.67.63-11.51.31C24,31,20.59,27.5,17.6,29.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.ff62a1e87d1821e2f9788670bf6465ed.svg";
export { ForwardRef as ReactComponent };